// extracted by mini-css-extract-plugin
export var iconHolder = "iconAndLink-module--iconHolder--57DPE";
export var link = "iconAndLink-module--link--3U9Nd";